import { CREATE_PAYMENT_SESSION } from 'redux/modules/payment/actions/types';

const reducer = state => ({
  ...state,
  currentApiRequest: CREATE_PAYMENT_SESSION.request,
});

export default reducer;
